import React, { useContext, useEffect, useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import Select from "react-select";
import "./Send_Button_Modal.css";
import Request_Send_Modal from "../../request-send-modal/Request_Send_Modal";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import {
  AllCartegory,
  AllDistrict,
  AllKilometer,
  AllPurchaseDate,
  AllState,
  AllSubServiceCategories,
  AllTaluka,
} from "../../../../features/admin/common/Slice";
import classNames from "classnames";
import { VendorEnquiry } from "../../../../features/admin/vendor_expert/Slice";
import { Context } from "../../../../utils/context";

function Send_Button_Modal({ vendor, show, handleClose }) {
  const { userdata } = useContext(Context);
  console.log(userdata, "userdatauserdata");

  const {
    control,
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    watch,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();

  const selectedState = watch("state_id");
  const selectedDistrict = watch("district_id");
  const constructionImageFile = watch("construction_image");
  const selectedCategory = watch("category_id");
  const [loading, setLoading] = useState(false); // new state

  const states = useSelector((state) => state?.common?.all_state);
  const districts = useSelector((state) => state?.common?.all_district);
  const categories = useSelector((state) => state?.common?.all_category);
  const all_kilometer = useSelector((state) => state?.common?.all_kilometer);
  const all_sub_service_categories = useSelector(
    (state) => state?.common?.all_sub_service_categories,
  );

  const all_taluka = useSelector((state) => state?.common?.all_taluka);

  const all_purchase_date = useSelector(
    (state) => state?.common?.all_purchase_date,
  );

  useEffect(() => {
    if (!show) return;
    dispatch(AllState());
    dispatch(AllCartegory());
    dispatch(AllPurchaseDate());
    dispatch(AllKilometer());
  }, [show, dispatch]);

  useEffect(() => {
    if (!show) return;
    if (selectedState?.value) {
      dispatch(AllDistrict({ state_id: selectedState.value }));
    } else {
      setValue("district_id", null);
    }
  }, [show, selectedState]);

  const handleStateChange = async (selectedOption) => {
    setValue("state_id", selectedOption);
    setValue("district_id", null);
    // setValue("taluqa_id", null);
    dispatch(AllDistrict({ state_id: selectedOption.value }));
  };

  const handleSubServiceCategoryChange = (selectedOption) => {
    setValue("category_id", selectedOption);
    setValue("service_category_id", null);

    dispatch(
      AllSubServiceCategories({
        service_category_id: [selectedOption.value],
      }),
    );
  };

  useEffect(() => {
    if (!show) return;
    if (selectedDistrict?.value) {
      dispatch(AllTaluka({ district_id: selectedDistrict.value }));
    } else {
      setValue("taluqa_id", null);
    }
  }, [show, selectedDistrict]);

  const [showRequestSent, setShowRequestSent] = useState(false);
  console.log(showRequestSent, "showRequestSentshowRequestSentshowRequestSent");

  const materialOptions = [
    { value: "plywood", label: "Plywood" },
    { value: "hardware", label: "Hardware" },
  ];

  const dateOptions = [
    { value: "week", label: "Within a Week" },
    { value: "month", label: "Within a Month" },
  ];

  const selectStyles = {};
  const handleRequestSendClick = () => {
    handleClose();
    setShowRequestSent(true);

    setTimeout(() => {
      setShowRequestSent(false);
    }, 3000);
  };

  const onSubmit = async (data) => {
    setLoading(true);
    const formData = new FormData();

    formData.append("name", data.name);
    formData.append("mobile_number", data.mobile);
    // formData.append("whatsapp_no", data.whatsapp_no);
    formData.append("description", data.description);
    formData.append("purchase_date", data.purchase_date?.value);
    formData.append("area", data.area);
    formData.append("kilometer", data.kilometer?.label || "");
    formData.append("state_id", data.state_id?.value);
    formData.append("district_id", data.district_id?.value);
    formData.append("taluqa_id", data.taluqa_id?.value);

    // data.category_id?.forEach((cat, index) => {
    //   formData.append(`material_id[${index}]`, cat.value);
    // });
    if (data.category_id) {
      formData.append("material_id[]", data.category_id.value);
    }

    if (data.service_category_id) {
      formData.append("sub_category_id[]", data.service_category_id.value);
    }

    if (data.construction_image?.length > 0) {
      formData.append("construction_image", data.construction_image[0]);
    }

    if (vendor?.user?.id) {
      formData.append("id", vendor?.user?.id);
    }

    try {
      const res = await dispatch(VendorEnquiry(formData));

      if (res.meta?.requestStatus === "fulfilled") {
        setShowRequestSent(true);
        setTimeout(() => {
          reset();
          handleClose();
          setShowRequestSent(false);
        }, 2000);
      }
    } catch (error) {
      console.error("Enquiry failed", error);
    } finally {
      setLoading(false); // hide loader
    }
  };

  useEffect(() => {
    if (showRequestSent) {
      const timer = setTimeout(() => {
        setShowRequestSent(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [showRequestSent]);

  useEffect(() => {
    if (!show || !userdata) return;

    // Basic fields
    setValue("name", userdata?.name || "");
    setValue("mobile", userdata?.mobile_number || "");

    // Nested user_details
    setValue("area", userdata?.user_details?.area || "");

    // State
    if (userdata?.user_details?.state) {
      setValue("state_id", {
        label: userdata.user_details.state.name,
        value: userdata.user_details.state.id,
      });
    }

    // District
    if (userdata?.user_details?.district) {
      setValue("district_id", {
        label: userdata.user_details.district.name,
        value: userdata.user_details.district.id,
      });
    }

    // Taluka (if exists)
    if (userdata?.user_details?.taluqa) {
      setValue("taluqa_id", {
        label: userdata.user_details.taluqa.name,
        value: userdata.user_details.taluqa.id,
      });
    }
  }, [show, userdata, setValue]);

  useEffect(() => {
    if (userdata?.user_details?.state?.id) {
      dispatch(AllDistrict({ state_id: userdata.user_details.state.id }));
    }
  }, [userdata]);

  useEffect(() => {
    if (userdata?.user_details?.district?.id) {
      dispatch(AllTaluka({ district_id: userdata.user_details.district.id }));
    }
  }, [userdata]);
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="inquiry-modal"
        size="md"
      >
        <Modal.Body className="p-4">
          <Form onSubmit={handleSubmit(onSubmit)}>
            {" "}
            <div className="Scroll-modal">
              <div className="custom-input-group">
                <span className="floating-label">Full Name*</span>

                <Form.Control
                  type="text"
                  placeholder="Full Name"
                  className={classNames("custom-input", {
                    "is-invalid": errors?.name,
                  })}
                  {...register("name", {
                    required: "Full Name is required",
                  })}
                />
              </div>
              {errors?.name && (
                <span className="invalid-feedback d-block mb-4">
                  {errors.name.message}
                </span>
              )}

              <div className="custom-input-group">
                <span className="floating-label">Mobile Number*</span>

                <Form.Control
                  type="text"
                  placeholder="4587523254"
                  className={classNames("custom-input", {
                    "is-invalid": errors?.mobile,
                  })}
                  {...register("mobile", {
                    required: "Mobile number is required",
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: "Mobile number must be exactly 10 digits",
                    },
                  })}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                  }}
                />
              </div>
              {errors?.mobile && (
                <span className="invalid-feedback d-block mb-4">
                  {errors.mobile.message}
                </span>
              )}

              {/* <div className="custom-input-group">
                <span className="floating-label">Whatsapp Mobile Number*</span>

                <Form.Control
                  type="text"
                  placeholder="4587523254"
                  className={classNames("custom-input", {
                    "is-invalid": errors?.whatsapp_no,
                  })}
                  {...register("whatsapp_no", {
                    required: "Whatsapp Mobile number is required",
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message:
                        "Whatsapp Mobile number must be exactly 10 digits",
                    },
                  })}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                  }}
                />
              </div>
              {errors?.whatsapp_no && (
                <span className="invalid-feedback d-block mb-4">
                  {errors.whatsapp_no.message}
                </span>
              )} */}

              <div className="custom-input-group">
                <span className="floating-label">Material*</span>

                <Controller
                  name="category_id"
                  control={control}
                  rules={{ required: "Category is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={categories}
                      styles={selectStyles}
                      classNamePrefix="react-select"
                      placeholder="Select Material"
                      isSearchable={false}
                      value={field.value || null} // ✅ important change
                      // onChange={(selected) => field.onChange(selected)}
                      onChange={handleSubServiceCategoryChange}
                    />
                  )}
                />
              </div>
              {errors?.category_id && (
                <span className="invalid-feedback d-block mb-4">
                  {errors.category_id.message}
                </span>
              )}

              <div className="custom-input-group">
                <span className="floating-label">Sub Material Category*</span>

                <Controller
                  name="service_category_id"
                  control={control}
                  rules={{ required: "Sub Material Category is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={all_sub_service_categories}
                      value={field.value || null}
                      onInputChange={(name) => {
                        if (selectedCategory?.value) {
                          dispatch(
                            AllSubServiceCategories({
                              category_id: selectedCategory.value,
                              name,
                            }),
                          );
                        }
                      }}
                      onChange={(selectedOption) => {
                        field.onChange(selectedOption);
                      }}
                    />
                  )}
                />
              </div>
              {errors?.service_category_id && (
                <span className="invalid-feedback d-block mb-4">
                  {errors.service_category_id.message}
                </span>
              )}

              <div className="custom-input-group">
                <span className="floating-label">Describe Your Material*</span>

                <Form.Control
                  type="textarea"
                  placeholder="Description"
                  className={classNames("custom-input", {
                    "is-invalid": errors?.description,
                  })}
                  {...register("description", {
                    required: "Description is required",
                    minLength: {
                      value: 2,
                      message: "Description must be at least 2 characters",
                    },
                  })}
                />
              </div>
              {errors?.description && (
                <span className="invalid-feedback d-block mb-4">
                  {errors.description.message}
                </span>
              )}

              <div className="custom-input-group">
                <span className="floating-label">Kilometer*</span>

                <Controller
                  name="kilometer"
                  control={control}
                  rules={{ required: "Kilometer is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={all_kilometer}
                      styles={selectStyles}
                      classNamePrefix="react-select"
                      placeholder="Select Kilometer"
                      isSearchable={false}
                      value={field.value || []}
                      onChange={(selected) => field.onChange(selected)}
                    />
                  )}
                />
              </div>
              {errors?.kilometer && (
                <span className="invalid-feedback d-block mb-4">
                  {errors.kilometer.message}
                </span>
              )}

              <div className="custom-input-group">
                <span className="floating-label">Purchase Date</span>

                <Controller
                  name="purchase_date"
                  control={control}
                  rules={{ required: "Purchase Date is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={all_purchase_date}
                      onInputChange={(val) => {
                        dispatch(AllPurchaseDate(val));
                      }}
                    />
                  )}
                />
              </div>
              {errors?.purchase_date && (
                <span className="invalid-feedback d-block mb-4">
                  {errors.purchase_date.message}
                </span>
              )}

              <div className="custom-input-group">
                <span className="floating-label">State*</span>

                <Controller
                  name="state_id"
                  control={control}
                  rules={{ required: "State is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={states}
                      styles={selectStyles}
                      classNamePrefix="react-select"
                      placeholder=""
                      onChange={handleStateChange}
                      onInputChange={(val) => {
                        dispatch(AllState(val));
                      }}
                    />
                  )}
                />
              </div>
              {errors?.state_id && (
                <span className="invalid-feedback d-block mb-4">
                  {errors.state_id.message}
                </span>
              )}

              <div className="custom-input-group">
                <span className="floating-label">District*</span>

                <Controller
                  name="district_id"
                  control={control}
                  rules={{ required: "District is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={districts}
                      styles={selectStyles}
                      placeholder=""
                      isDisabled={!selectedState}
                      onChange={(selectedOption) => {
                        field.onChange(selectedOption);
                      }}
                    />
                  )}
                />
              </div>
              {errors?.district_id && (
                <span className="invalid-feedback d-block mb-4">
                  {errors.district_id.message}
                </span>
              )}

              <div className="custom-input-group">
                <span className="floating-label">Taluka*</span>

                <Controller
                  name="taluqa_id"
                  control={control}
                  rules={{ required: "Taluka is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={all_taluka}
                      styles={selectStyles}
                      classNamePrefix="react-select"
                      placeholder="Taluka"
                      isDisabled={!selectedDistrict}
                      onChange={(selectedOption) =>
                        field.onChange(selectedOption)
                      }
                    />
                  )}
                />
              </div>
              {errors?.taluqa_id && (
                <span className="invalid-feedback d-block mb-4">
                  {errors.taluqa_id.message}
                </span>
              )}

              <div className="custom-input-group">
                <span className="floating-label">Area*</span>

                <Form.Control
                  type="text"
                  placeholder="Area"
                  className={classNames("custom-input", {
                    "is-invalid": errors?.area,
                  })}
                  {...register("area", {
                    required: "Area is required",
                    minLength: {
                      value: 2,
                      message: "Area must be at least 2 characters",
                    },
                  })}
                />
              </div>
              {errors?.area && (
                <span className="invalid-feedback d-block mb-4">
                  {errors.area.message}
                </span>
              )}

              <div className="custom-input-group upload-section">
                <span className="floating-label">Upload Material Image</span>

                <Form.Control
                  type="file"
                  accept=".jpg,.jpeg,.png"
                  className={classNames("custom-file-input", {
                    "is-invalid": errors?.construction_image,
                  })}
                  {...register("construction_image", {
                    required: "Material Image is required",
                    validate: (value) => {
                      if (!value || value.length === 0)
                        return "Material Image is required";

                      const allowedTypes = [
                        "image/jpeg",
                        "image/png",
                        "image/jpg",
                      ];

                      if (!allowedTypes.includes(value[0].type)) {
                        return "Only JPG, JPEG, PNG files allowed";
                      }

                      return true;
                    },
                  })}
                />
              </div>
              {errors?.construction_image && (
                <span className="invalid-feedback d-block mb-4">
                  {errors.construction_image.message}
                </span>
              )}
              {constructionImageFile && constructionImageFile.length > 0 && (
                <div className="image-preview-container mt-2">
                  <img
                    src={URL.createObjectURL(constructionImageFile[0])}
                    alt="Construction Preview"
                    style={{
                      width: "120px",
                      height: "120px",
                      objectFit: "cover",
                      borderRadius: "8px",
                      border: "1px solid #ddd",
                    }}
                  />
                </div>
              )}
            </div>
            <div className="text-center mt-4">
              {/* <Button type="submit" className="submit-inquiry-pill">
                Send Inquiry
              </Button> */}
              <Button
                type="submit"
                className="submit-inquiry-pill"
                disabled={loading}
              >
                {loading ? "Sending..." : "Send Inquiry"}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Request_Send_Modal
        showRequestSent={showRequestSent}
        handleRequestSendClose={() => setShowRequestSent(false)}
        message="Inquiry Sent Successfully!"
      />
    </>
  );
}

export default Send_Button_Modal;
